import React, { useContext } from 'react'
import { CashflowEventsContext } from '../../context'
import { CardContent, CardFooter } from '../../../../components/layout/Card'
import { Button } from '../../../../components/Button'

export const EventTypeScreen = () => {
  const { actions } = useContext(CashflowEventsContext)
  const { addEventType, goToOverview } = actions
  return (
    <>
      <CardContent className='cashflow-events cashflow-events--background-grey'>
        <div className='cashflow-events__options'>
          <div className='grid grid-cols-2 gap-4'>
            <TypeOption text='Income' onClick={() => addEventType('income')} />
            <TypeOption text='Expense' onClick={() => addEventType('expense')} />
            <div className='cashflow-event-card__or hidden sm:block'><h1>OR</h1></div>
          </div>
        </div>
      </CardContent>
      <CardFooter>
        <Button tertiary onClick={goToOverview}>Back</Button>
      </CardFooter>
    </>
  )
}

const TypeOption = ({ text, onClick }) =>
  <div className='cashflow-event-card__option' onClick={onClick}>
    <h3>{text}</h3>
  </div>
